function IsWistiaEmbedVideo (url) {	
	if (url != null && (url.startsWith("https://fast.wistia.net/embed/iframe/") || url.startsWith("https://home.wistia.com/medias/"))) {
		return true;
	}
	else {
		return false;
	}
}
export default IsWistiaEmbedVideo;
